// extracted by mini-css-extract-plugin
module.exports = {"zoomBlock":"ZoomBlock_zoomBlock__41_0R"};